// Mapping of unit_model → standard submittal-drawing PDFs.
// Files live in /public/submittal-drawings/ and are fetched at runtime.

const BASE = "/submittal-drawings/";

// Each entry: { file, label } describing the standard drawing to bake into the
// submittal PDF when the project uses this unit model. Order matters — when a
// model is mapped to multiple drawings, they're appended in the listed order.
//
// Models with `bySystem` instead of `file` provide separate IP / SI versions.
// `drawingsForRooms` will pick the matching one based on the project's
// `isSI` flag.
const DRAWINGS_BY_MODEL = {
  "Model S":    [{ file: "spinnaker-sv.pdf",  label: "Spinnaker SV — Slimline Submittal Drawings" }],
  "Model O-1":  [{ file: "spinnaker-sc.pdf",  label: "Spinnaker SC — Slimline Submittal Drawings" }],
  "Model I-T":  [{
    bySystem: { si: "model-i-t-si.pdf", ip: "model-i-t-ip.pdf" },
    label: "Model I-T — Submittal Drawings",
  }],
  "Model I-L":  [{ file: "fmlby.pdf",         label: "FMLBY — Submittal Drawings" }],
  "Model I-F":  [{ file: "fmfby.pdf",         label: "FMFBY — Submittal Drawings" }],
  "Model L-L":  [{
    bySystem: { si: "model-l-l-si.pdf", ip: "model-l-l-ip.pdf" },
    label: "Model L-L — Submittal Drawings",
  }],
  "Model L-T":  [{ file: "acb-35.pdf",        label: "ACB-35 — Submittal Drawings" }],
  "Model H":    [{ file: "acb-10.pdf",        label: "ACB-10 — Submittal Drawings" }],
  "Model C":    [{ file: "acb-40-50.pdf",     label: "ACB-40 / ACB-50 — Submittal Drawings" }],
  // Model D shares Model C's submittal drawing until a dedicated drawing
  // is uploaded via Admin → Model Assets. Admin-uploaded files override
  // this fallback automatically (see Submittal Package tab).
  "Model D":    [{ file: "acb-40-50.pdf",     label: "ACB-40 / ACB-50 — Submittal Drawings (shared)" }],
};

// Given the project's rooms, return the deduplicated list of drawing files to
// append, in the order the models first appear. `isSI` chooses SI vs IP for
// the models that ship both versions.
export function drawingsForRooms(rooms, isSI = false) {
  const system = isSI ? "si" : "ip";
  const seen = new Set();
  const out = [];
  (rooms || []).forEach((r) => {
    const model = r.unit_model;
    const draws = DRAWINGS_BY_MODEL[model];
    if (!draws) return;
    draws.forEach((d) => {
      const file = d.bySystem ? d.bySystem[system] : d.file;
      if (!file) return;
      if (seen.has(file)) return;
      seen.add(file);
      out.push({ file, label: d.label, url: BASE + file, model });
    });
  });
  return out;
}

// Fetch a PDF as ArrayBuffer.
export async function fetchDrawingBytes(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to fetch ${url}: ${res.status}`);
  return res.arrayBuffer();
}
